import { Component, Input } from '@angular/core';
import { CustomerMedicalNotes, CustomerNote } from '../../../../../../../models/customer';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from '../../../../../../../services/customer/customer.service';
import { CallbackResult, CallbackResultStatus } from '../../../../../../../utils';

@Component({
  selector: 'app-customer-medical-notes-modal',
  templateUrl: './customer-medical-notes-modal.component.html',
  styleUrls: ['./customer-medical-notes-modal.component.css']
})
export class CustomerMedicalNotesModalComponent {

  @Input() notes: CustomerMedicalNotes;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public inEditMode = false;

  public loadingSubmit = false;
  public errors: any = {};
  public errorMessage = '';
  public serverError: number = null;

  constructor(
    public activeModal: NgbActiveModal,
    public customerService: CustomerService
  ) {}

  public handleSaveEdit() {
    this.loadingSubmit = true;

    this.errorMessage = '';

    this.customerService
      .updateCustomerMedicalNotes(
        this.notes
      )
      .then(notes => {
        this.savedCallback({
          text: 'Medical notes updated successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please correct the errors above and try again.';
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to edit these medical notes.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

  public handleRemove() {
    this.errorMessage = '';

    if (!confirm('Are you sure you want to remove these medical notes? This action cannot be undone.')) { return; }

    this.loadingSubmit = true;

    this.customerService
      .removeCustomerMedicalNotes(this.notes)
      .then(() => {
        this.savedCallback({
          text: 'Medical notes removed successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to remove these medical notes.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

}
